import mitt from 'mitt';

if (!window.__eventBus) {
    window.__eventBus = mitt();
}

export default window.__eventBus;
